/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { BroadcastType, FindBroadcastTypeParams } from 'types';

const find = async (params: ?FindBroadcastTypeParams): Promise<BroadcastType[]> => {
  const { productionTypeId, usageTypeId } = params || {};
  const response = await callLiferayEndpoint(
    '/protones-portlet.tipologieemissione/find-by-tipologia-produzione-and-tipologia-utilizzo',
    {
      tipologiaProduzioneId: productionTypeId || 0,
      tipologiaUtilizzoId: usageTypeId || 0,
    }
  );
  return response.map(utils.toBroadcastType);
};

export default {
  find,
};
